// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/canvas/nodes/AudioTrimNode.css */

.AudioTrimNode-container {
  background: white;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  min-width: 280px;
  position: relative;
}

/* 复制按钮 */
.AudioTrimNode-duplicate-button {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;
  z-index: 10;
}

.AudioTrimNode-duplicate-button:hover {
  background: #f3f4f6;
  color: #374151;
}

/* 标题栏 */
.AudioTrimNode-title {
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  border-bottom: 1px solid #e5e7eb;
}

/* 内容区域 */
.AudioTrimNode-wrapper {
  padding: 12px 16px;
}

/* ========== Handle 样式 ========== */
.AudioTrimNode-handle {
  width: 14px;
  height: 14px;
  border: 2px solid white;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.AudioTrimNode-handle:hover {
  width: 18px;
  height: 18px;
  border-width: 3px;
}

.AudioTrimNode-handle-audio {
  background: #f59e0b;
  border-color: #f59e0b;
}

.AudioTrimNode-handle-output {
  background: #10b981;
  border-color: #10b981;
}

/* Handle 标签样式 */
.AudioTrimNode-handle-label {
  position: absolute;
  top: -28px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.75);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: 10;
}

.AudioTrimNode-handle:hover .AudioTrimNode-handle-label {
  opacity: 1;
}

.react-flow__node.selected .AudioTrimNode-handle .AudioTrimNode-handle-label {
  opacity: 1;
}

.AudioTrimNode-handle-label-clickable {
  pointer-events: auto;
  cursor: pointer;
}

.AudioTrimNode-handle-label-clickable:hover {
  background: rgba(0, 0, 0, 0.9);
}

/* ========== 连接状态 ========== */
.AudioTrimNode-status {
  margin-bottom: 12px;
}

.AudioTrimNode-status-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}

.AudioTrimNode-status-label {
  color: #6b7280;
}

.AudioTrimNode-status-value {
  font-weight: 500;
}

.AudioTrimNode-status-connected {
  color: #10b981;
}

.AudioTrimNode-status-disconnected {
  color: #ef4444;
}

/* ========== 配置区域 ========== */
.AudioTrimNode-config {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 12px;
}

.AudioTrimNode-row {
  display: flex;
  gap: 10px;
}

.AudioTrimNode-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
}

.AudioTrimNode-field label {
  font-size: 12px;
  font-weight: 500;
  color: #374151;
}

.AudioTrimNode-field input,
.AudioTrimNode-field select {
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: white;
  color: #374151;
  font-size: 13px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.AudioTrimNode-field input:focus,
.AudioTrimNode-field select:focus {
  outline: none;
  border-color: #f59e0b;
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.2);
}

.AudioTrimNode-field input:disabled,
.AudioTrimNode-field select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #f3f4f6;
}

.AudioTrimNode-field input::placeholder {
  color: #9ca3af;
}

/* ========== 按钮样式 ========== */
.AudioTrimNode-btn {
  width: 100%;
  padding: 10px 16px;
  border: none;
  border-radius: 6px;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.AudioTrimNode-btn:hover:not(.AudioTrimNode-btn-disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.4);
}

.AudioTrimNode-btn-disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* ========== 进度条 ========== */
.AudioTrimNode-progress {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 12px;
}

.AudioTrimNode-progress-bar {
  width: 100%;
  height: 8px;
  background: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
}

.AudioTrimNode-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #f59e0b 0%, #d97706 100%);
  transition: width 0.3s ease;
}

.AudioTrimNode-progress-text {
  font-size: 12px;
  color: #6b7280;
  text-align: center;
}

/* ========== 错误提示 ========== */
.AudioTrimNode-error {
  padding: 10px 12px;
  margin-bottom: 12px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 6px;
  color: #dc2626;
  font-size: 12px;
  line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/AudioTrimNode.css"],"names":[],"mappings":"AAAA,kDAAkD;;AAElD;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,QAAQ;AACR;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA,SAAS;AACT;EACE,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,8CAA8C;AAChD;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,4DAA4D;EAC5D,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB","sourcesContent":["/* src/components/canvas/nodes/AudioTrimNode.css */\n\n.AudioTrimNode-container {\n  background: white;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n  min-width: 280px;\n  position: relative;\n}\n\n/* 复制按钮 */\n.AudioTrimNode-duplicate-button {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 24px;\n  height: 24px;\n  border: none;\n  background: transparent;\n  color: #9ca3af;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s;\n  z-index: 10;\n}\n\n.AudioTrimNode-duplicate-button:hover {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n/* 标题栏 */\n.AudioTrimNode-title {\n  padding: 12px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n/* 内容区域 */\n.AudioTrimNode-wrapper {\n  padding: 12px 16px;\n}\n\n/* ========== Handle 样式 ========== */\n.AudioTrimNode-handle {\n  width: 14px;\n  height: 14px;\n  border: 2px solid white;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.AudioTrimNode-handle:hover {\n  width: 18px;\n  height: 18px;\n  border-width: 3px;\n}\n\n.AudioTrimNode-handle-audio {\n  background: #f59e0b;\n  border-color: #f59e0b;\n}\n\n.AudioTrimNode-handle-output {\n  background: #10b981;\n  border-color: #10b981;\n}\n\n/* Handle 标签样式 */\n.AudioTrimNode-handle-label {\n  position: absolute;\n  top: -28px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(0, 0, 0, 0.75);\n  color: white;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  white-space: nowrap;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n  z-index: 10;\n}\n\n.AudioTrimNode-handle:hover .AudioTrimNode-handle-label {\n  opacity: 1;\n}\n\n.react-flow__node.selected .AudioTrimNode-handle .AudioTrimNode-handle-label {\n  opacity: 1;\n}\n\n.AudioTrimNode-handle-label-clickable {\n  pointer-events: auto;\n  cursor: pointer;\n}\n\n.AudioTrimNode-handle-label-clickable:hover {\n  background: rgba(0, 0, 0, 0.9);\n}\n\n/* ========== 连接状态 ========== */\n.AudioTrimNode-status {\n  margin-bottom: 12px;\n}\n\n.AudioTrimNode-status-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n}\n\n.AudioTrimNode-status-label {\n  color: #6b7280;\n}\n\n.AudioTrimNode-status-value {\n  font-weight: 500;\n}\n\n.AudioTrimNode-status-connected {\n  color: #10b981;\n}\n\n.AudioTrimNode-status-disconnected {\n  color: #ef4444;\n}\n\n/* ========== 配置区域 ========== */\n.AudioTrimNode-config {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.AudioTrimNode-row {\n  display: flex;\n  gap: 10px;\n}\n\n.AudioTrimNode-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex: 1;\n}\n\n.AudioTrimNode-field label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #374151;\n}\n\n.AudioTrimNode-field input,\n.AudioTrimNode-field select {\n  padding: 8px 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background: white;\n  color: #374151;\n  font-size: 13px;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.AudioTrimNode-field input:focus,\n.AudioTrimNode-field select:focus {\n  outline: none;\n  border-color: #f59e0b;\n  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.2);\n}\n\n.AudioTrimNode-field input:disabled,\n.AudioTrimNode-field select:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background: #f3f4f6;\n}\n\n.AudioTrimNode-field input::placeholder {\n  color: #9ca3af;\n}\n\n/* ========== 按钮样式 ========== */\n.AudioTrimNode-btn {\n  width: 100%;\n  padding: 10px 16px;\n  border: none;\n  border-radius: 6px;\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  color: white;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.AudioTrimNode-btn:hover:not(.AudioTrimNode-btn-disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.4);\n}\n\n.AudioTrimNode-btn-disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* ========== 进度条 ========== */\n.AudioTrimNode-progress {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 12px;\n}\n\n.AudioTrimNode-progress-bar {\n  width: 100%;\n  height: 8px;\n  background: #e5e7eb;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.AudioTrimNode-progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #f59e0b 0%, #d97706 100%);\n  transition: width 0.3s ease;\n}\n\n.AudioTrimNode-progress-text {\n  font-size: 12px;\n  color: #6b7280;\n  text-align: center;\n}\n\n/* ========== 错误提示 ========== */\n.AudioTrimNode-error {\n  padding: 10px 12px;\n  margin-bottom: 12px;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 6px;\n  color: #dc2626;\n  font-size: 12px;\n  line-height: 1.4;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
